import { StockPublicationSettings } from "../types";

export const cloneSettings = (
  settings: StockPublicationSettings,
): StockPublicationSettings => ({
  ...settings,
  hiddenBrands: [...settings.hiddenBrands],
  hiddenModels: [...settings.hiddenModels],
  hiddenSizes: [...settings.hiddenSizes],
  hiddenDrillings: [...settings.hiddenDrillings],
  markups: settings.markups.map((rule) => ({ ...rule })),
});
